import { mapGetters, mapMutations } from "vuex"

export default {
    computed:{
        ...mapGetters(['uncompleted_contents','content','contents','module']),
        activeTab :{
            get(){
              return this.module ? this.module.activeTab : 0
            },
            set(value){
              this.$store.state.module.current.activeTab =  value
            }
        },
    },
    methods: {
        ...mapMutations(['SET_MODULE'])
    }
}